<template>
    <div :style="style"></div>
</template>

<script>
    export default {
        props: {
            space: {
                type: Number,
                default: 24
            },
            color: {
                type: String,
                default: '#F0F2F5'
            },
            bottom: {
                type: Number,
                default: 0
            },
            left: {
                type: Number,
                default: 0
            },
            right: {
                type: Number,
                default: 0
            },
            top: {
                type: Number,
                default: 0
            }
        },
        computed: {
            style() {
                return {
                    backgroundColor: this.color,
                    height: this.space + 'px',
                    marginBottom: this.bottom + 'px',
                    marginLeft: this.left + 'px',
                    marginRight: this.right + 'px',
                    marginTop: this.top + 'px'
                }
            }
        }
    }
</script>